/**
 * plantImageUtils.js
 *
 * Utility for constructing plant image URLs from plant names.
 *
 * Plant images are static WebP assets served from Vercel CDN.
 * Structure: /images/plants/{variant}/{name}.webp
 *
 * Variants:
 *   'thumb'   — 60×60px   (CompactPlantCard, property panel)
 *   'catalog' — 150×150px (PlantCard, catalog view)
 *   'detail'  — 512×512px (PlantDetailDialog)
 *
 * ADR-026: image_url column removed from DB; URLs derived from plant.name.
 */

/**
 * Returns the URL for a plant image variant.
 *
 * @param {string|null} plantName - The German trivial name (plant.name)
 * @param {'thumb'|'catalog'|'detail'} variant - Image size variant
 * @returns {string|null} URL or null if plantName is falsy
 */
export const getPlantImageUrl = (plantName, variant = 'catalog') => {
  if (!plantName) return null;
  return `/images/plants/${variant}/${encodeURIComponent(plantName)}.webp`;
};
